import React from 'react'
import { Badge, Button, Tooltip } from 'antd'
import { FileTextOutlined } from '@ant-design/icons';
import _ from 'lodash';

const NotesNotification = ({id, onViewNote=_.noop, notesCountStats}) => {
    return notesCountStats?.notesAvailable ? (
        <Button id={id} type='text' style={{background:"none", boxShadow:"none", padding:0}}>
            <Tooltip title={<>{notesCountStats?.unreadNotesCount} unread notes</>} placement="top" overlayStyle={{ maxWidth: '500px' }}>
                <Badge onClick={()=>onViewNote(id)} size='small' style={{fontSize:8, fontWeight:700}} count={notesCountStats?.unreadNotesCount}>
                    <FileTextOutlined style={{fontSize:20}} fill={notesCountStats?.unreadNotesCount ? "#35198E" : "none"} />
                </Badge>
            </Tooltip>
        </Button>
    ) : null;
}

export default NotesNotification;